/**
 * SetSlider Class
 */
export default class SetSlider {

	slider;

	mediaQueryBreakpoint;

	imageElement;

	swiperButtons;

	progressBar;

	/**
	 * Constructor
	 *
	 * @param {object} slider
	 * @return {void}
	 */
	constructor( slider ) {

		this.slider = slider;
		this.mediaQueryBreakpoint = window.matchMedia( "(max-width: 767px)" );
		this.imageElement = slider.querySelector( ".c-slide-gallery__image" );
		this.swiperButtons = slider.querySelectorAll( ".swiper-button" );
		this.progressBar = slider.querySelector( ".swiper-pagination.swiper-pagination-progressbar" );

	}

	initSliderSettings = () => {

		this.setSliderButtonsOnMobile();
		this.setProgressBarPosition();
		this.setSliderSettingsOnResize();

	}

	/**
	 * Sets the top position of the slider buttons on mobile devices based on the height of the image element.
	 *
	 */
	setSliderButtonsOnMobile = () => {

		if ( this.mediaQueryBreakpoint.matches ) {

			const imageElementHeight = this.imageElement.offsetHeight - 60;

			this.swiperButtons.forEach( ( button ) => {

				button.style.top = `${imageElementHeight}px`;

			} );

		}

	};

	/**
	 * Set ProgressBar Position.
	 *
	 */
	setProgressBarPosition = () => {


		if ( this.mediaQueryBreakpoint.matches ) {

			const imageElementHeight = this.imageElement.offsetHeight - 54;

			if ( this.progressBar ) {

				this.progressBar.style.top = `${imageElementHeight}px`;

			}

		}

	}

	/**
	 * Set slider buttons and progressBar positions on resize.
	 *
	 */
	setSliderSettingsOnResize = () => {

		window.addEventListener( "resize", () => {

			if ( this.mediaQueryBreakpoint.matches ) {

				const imageElementHeight = this.imageElement.offsetHeight - 60;
				const imageElementHeightForProgressBar = this.imageElement.offsetHeight - 54;

				this.swiperButtons.forEach( ( button ) => {

					button.style.top = `${imageElementHeight}px`;

				} );

				if ( this.progressBar ) {

					this.progressBar.style.top = `${imageElementHeightForProgressBar}px`;

				}

			} else {

				this.swiperButtons.forEach( ( button ) => {

					button.style.top = `0`;

				} );

			}

		} );

	}

}

